var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.164062 30.016V2.88328C0.164062 2.14051 0.440736 1.51747 0.994081 1.01413C1.54743 0.510803 2.19299 0.260011 2.93079 0.261758C3.16135 0.261758 3.4039 0.294091 3.65844 0.358755C3.91297 0.423419 4.1546 0.522163 4.38332 0.654986L26.9321 14.2213C27.3471 14.4835 27.6589 14.8112 27.8673 15.2044C28.0757 15.5976 28.179 16.0127 28.1772 16.4496C28.1753 16.8866 28.072 17.3016 27.8673 17.6949C27.6625 18.0881 27.3508 18.4158 26.9321 18.6779L4.38332 32.2443C4.15276 32.3754 3.91113 32.4741 3.65844 32.5405C3.40574 32.6069 3.16319 32.6393 2.93079 32.6375C2.19299 32.6375 1.54743 32.3859 0.994081 31.8825C0.440736 31.3792 0.164063 30.757 0.164062 30.016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.1e2457bd524ffd90e3a8ad755a04c2a0.svg";
export { ForwardRef as ReactComponent };